import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import apiService from '../../services/apiService';
import martechLogo from '../../assets/Asset 2.png';

const LoginPage = () => {
    const [isLoginView, setIsLoginView] = useState(true);
    const { refetchUser } = useAuth();
    const [error, setError] = useState('');
    
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await apiService.login(email, password);
            await refetchUser();
        } catch (err) {
            setError(err.message);
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await apiService.register(name, email, password);
            await refetchUser();
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="min-h-screen bg-[#040E22] flex flex-col items-center justify-center text-white p-4 font-poppins">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <img src={martechLogo} alt="MartechAI Logo" className="w-16 h-16 mx-auto mb-4" />
                    <h1 className="text-4xl font-bold mb-2">Welcome to MartechAI</h1>
                    <p className="text-slate-400">{isLoginView ? "Sign in to your account" : "Create a new account"}</p>
                </div>
                <div className="bg-slate-800/50 p-8 rounded-lg border border-slate-700">
                    <form onSubmit={isLoginView ? handleLogin : handleRegister} className="space-y-6">
                        {!isLoginView && (
                            <div>
                                <label className="block mb-2 text-sm font-medium text-slate-300">Name</label>
                                <input type="text" value={name} onChange={e => setName(e.target.value)} required className="bg-slate-700 border border-slate-600 text-white text-sm rounded-lg block w-full p-2.5" />
                            </div>
                        )}
                        <div>
                            <label className="block mb-2 text-sm font-medium text-slate-300">Email</label>
                            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="bg-slate-700 border border-slate-600 text-white text-sm rounded-lg block w-full p-2.5" />
                        </div>
                        <div>
                            <label className="block mb-2 text-sm font-medium text-slate-300">Password</label>
                            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="bg-slate-700 border border-slate-600 text-white text-sm rounded-lg block w-full p-2.5" />
                        </div>
                        {error && <p className="text-red-400 text-sm text-center">{error}</p>}
                        <button type="submit" className="w-full bg-[#16e2c3] text-black font-bold py-3 px-4 rounded-md hover:bg-opacity-80 transition-opacity">
                            {isLoginView ? 'Sign In' : 'Create Account'}
                        </button>
                    </form>
                    <div className="relative my-6">
                        <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-600"></div></div>
                        <div className="relative flex justify-center text-sm"><span className="px-2 bg-slate-800 text-slate-400">Or continue with</span></div>
                    </div>
                    <a href={apiService.getGoogleLoginUrl()} className="w-full bg-slate-700 text-white font-bold py-3 px-4 rounded-md hover:bg-slate-600 transition-colors flex items-center justify-center gap-2">
                        <svg className="w-5 h-5" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.574l6.19,5.238C41.38,36.168,44,30.638,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path></svg>
                        Sign In with Google
                    </a>
                </div>
                <p className="text-center text-sm text-slate-400 mt-6">
                    {isLoginView ? "Don't have an account?" : "Already have an account?"}
                    <button onClick={() => setIsLoginView(!isLoginView)} className="font-medium text-[#16e2c3] hover:text-opacity-80 ml-1">
                        {isLoginView ? 'Sign Up' : 'Sign In'}
                    </button>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;